#import "./sales-automation-stage.graphql"
#import "./closed-lead-automation-fragment.graphql"
#import "./lead-distribution-automation.graphql"

fragment SalesAutomationStageset on Stageset {
    id
    name
    htmlUrlPath
    default
    position
    canDelete
    isArchived
    modifiedTime
    modifiedUser {
        id
        name
    }
    stages {
        ...SalesAutomationStage
    }
    editableProcessTemplate {
        closedLeadAutomations {
            ...SalesAutomationClosedLeadAutomation
        }
    }
    leadDistributionAutomation {
        ...LeadDistributionAutomation
    }
    status
    numOfOpenLeads
}
